import { toggle } from "@otto-ec/global-resources/toggle";
import { on } from "svelte/events";

/**
 *
 *
 *
 *
 *
 *
 *
 */
export const setupRemover = (form: HTMLFormElement, submitter: HTMLElement): void => {
  if (toggle.get("oc_button_submit_handle_prevent", false)) {
    const unset = on(form, "submit", (ev) => {
      if (ev.defaultPrevented) return;
      unset();
      form.removeChild(submitter);
    });
  } else {
    form.removeChild(submitter);
  }
};

/**
 *
 *
 */
export function requestSubmit(form: HTMLFormElement | null, element: HTMLElement): void {
  if (!form || !element) {
    return;
  }

  const submitter = element.cloneNode(true) as HTMLElement;
  submitter.style.display = "none";

  /*                                                                                */
  /*                                                                                */
  /*                                                                                 */
  /*                                                                                        */
  /*        */
  setTimeout(() => setupRemover(form, submitter), 0);

  form.appendChild(submitter);
  form.requestSubmit(submitter);
}
